import { render, staticRenderFns } from "./selectOnTheMap.vue?vue&type=template&id=97cfd4b6&scoped=true"
import script from "./selectOnTheMap.vue?vue&type=script&lang=js"
export * from "./selectOnTheMap.vue?vue&type=script&lang=js"
import style0 from "./selectOnTheMap.vue?vue&type=style&index=0&id=97cfd4b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cfd4b6",
  null
  
)

export default component.exports